import NotificationService from "@/services/NotificationService";

const state = () => ({
  notifications: [],
  hasUnreadNotifications: false,
  page: 0,
});

const getters = {
  getNotifications: (state) => {
    return state.notifications;
  },
  hasAnyUnreadNotifications: (state) => {
    return state.hasUnreadNotifications;
  },
};

const actions = {
  setNotificationsRead({ commit }) {
    commit("setHasUnreadNotifications", false);
  },
  fetchNotifications({ commit, state }) {
    return NotificationService.getNotifications({
      limit: 12,
      offset: state.page * 12,
    }).then(
      (response) => {
        const notifications = response.data;
        commit("notificationsNextPage");
        commit("appendNotifications", notifications);
        return Promise.resolve(notifications);
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        return Promise.reject(message);
      }
    );
  },
  checkForUnreadNotifications({ commit }) {
    return NotificationService.getNotifications({
      limit: 20,
      offset: 0,
    }).then(
      (response) => {
        const notifications = response.data;
        const hasUnreadNotifications =
          notifications.filter((n) => n.isUnread).length > 0;
        commit("setHasUnreadNotifications", hasUnreadNotifications);
        return Promise.resolve(hasUnreadNotifications);
      },
      (error) => {
        return Promise.resolve(false);
      }
    );
  },
  resetNotifications({ commit }) {
    commit("clearNotifications");
  },
  markAllNotificationsRead({ commit }) {
    commit("markAllRead");
  },
  markNotificationAsRead({ commit }, id) {
    commit("markNotificationRead", id);
    return NotificationService.markNotificationsAsRead(id);
  },
};

const mutations = {
  appendNotifications(state, notifications) {
    state.notifications.push(...notifications);
  },
  notificationsNextPage(state) {
    state.page += 1;
  },
  setHasUnreadNotifications(state, hasUnread) {
    state.hasUnreadNotifications = hasUnread;
  },
  clearNotifications(state) {
    state.notifications = [];
  },
  markAllRead(state) {
    state.notifications.forEach((n) => (n.isUnread = false));
  },
  markNotificationRead(state, id) {
    const index = state.notifications.findIndex((n) => n.id === id);
    if (index > -1) {
      const notification = state.notifications[index];
      notification.isUnread = false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
